import { getBytes, listAll, ref, uploadBytes } from 'firebase/storage'
import { storage } from './firebaseClient'

const LOGS_FOLDER = 'Logs'

function pad(value) {
  return String(value).padStart(2, '0')
}

export function auditLogFilename(date = new Date()) {
  return `logs-${date.getFullYear()}-${pad(date.getMonth() + 1)}.json`
}

function logPath(filename) {
  return `${LOGS_FOLDER}/${filename}`
}

function textFromBytes(bytes) {
  return new TextDecoder('utf-8').decode(bytes)
}

function normalizeLogItems(value) {
  return Array.isArray(value) ? value : []
}

function createLogId() {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID()
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

export async function readAuditLogFile(filename = auditLogFilename()) {
  try {
    const bytes = await getBytes(ref(storage, logPath(filename)))
    return normalizeLogItems(JSON.parse(textFromBytes(bytes)))
  } catch (error) {
    if (error && error.code === 'storage/object-not-found') return []
    throw error
  }
}

export async function writeAuditLogFile(filename, items) {
  const body = JSON.stringify(normalizeLogItems(items), null, 2)
  await uploadBytes(ref(storage, logPath(filename)), new Blob([body], {
    type: 'application/json;charset=utf-8'
  }))
}

export async function appendAuditLog(payload) {
  const timestamp = new Date().toISOString()
  const filename = auditLogFilename(new Date(timestamp))
  const currentItems = await readAuditLogFile(filename)
  const item = {
    id: createLogId(),
    timestamp,
    action: payload.action || 'update',
    entityType: payload.entityType || 'unknown',
    entityId: payload.entityId || '',
    title: payload.title || '',
    actor: {
      uid: payload.actor?.uid || '',
      name: payload.actor?.name || '',
      role: payload.actor?.role || ''
    },
    route: payload.route || '',
    details: payload.details && typeof payload.details === 'object' ? payload.details : {}
  }

  await writeAuditLogFile(filename, currentItems.concat(item))
  return { item, filename }
}

export async function listAuditLogFiles() {
  const currentFilename = auditLogFilename()
  const result = await listAll(ref(storage, LOGS_FOLDER))
  const filenames = result.items
    .map(item => item.name)
    .filter(name => /^logs-\d{4}-\d{2}\.json$/.test(name))

  if (!filenames.includes(currentFilename)) filenames.push(currentFilename)
  return filenames.sort().reverse()
}
